import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Company from "./components/Company";
import Centre from "./components/Centre/Centre";
import Haulier from "./components/Haulier/Haulier";

import {
  DocumentListViewContainer,
  SectionContainer,
  HeaderButton,
  HeaderRow,
  Circle,
} from "./AddEditCompany.styled";
import { loadSingleCompany } from "../CompanyList/CompanyList.actionCreators";

const AddEditCompany = (props) => {
  const {
    t,
    id,
    isEditMode,
    isCompanyCreation,
    isCenterCreation,
    companyData,
  } = props;
  const dispatch = useDispatch();
  const params = useParams();
  const queryParams = new URLSearchParams(window.location.search);
  const leadId = queryParams.get("leadId");
  const [activeTab, setActiveTab] = useState("company");
  const [displayCenter, setDisplayCenter] = useState(isCenterCreation);
  const [displayHaulier, setDisplayHaulier] = useState(true);
  const [haulierNum, setHaulierNum] = useState(2);

  const companyId = parseInt(params.id, 10);
  const companyInfo = useSelector((state) => state.companyList.byId[id]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const selectedCompanyData = useSelector(
    (state) => state.companyList.selectedCompany
  );

  const [typeData, setTypeData] = useState(JSON.stringify([]));

  const fetchCompanyInfo = () => {
    dispatch(
      loadSingleCompany({
        companyId,
      })
    );
  };

  useEffect(() => {
    if (companyInfo === undefined && (isEditMode || companyId)) {
      fetchCompanyInfo();
    }
  }, [companyInfo, companyId]);

  useEffect(() => {
    if (
      companyInfo !== undefined &&
      parseInt(companyId, 10) === parseInt(companyInfo.id, 10)
    ) {
      setSelectedCompany(companyInfo);
    }
    if (
      selectedCompanyData !== null &&
      parseInt(companyId, 10) === parseInt(selectedCompanyData.id, 10)
    ) {
      setSelectedCompany(selectedCompanyData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo, selectedCompanyData]);

  const toggleTab = (tab) => {
    if (selectedCompany?.id) setActiveTab(tab);
  };

  // onchange of type data
  useEffect(() => {
    let typeDataArr = JSON.parse(typeData);
    typeDataArr.indexOf(4) !== -1
      ? setDisplayCenter(true)
      : setDisplayCenter(false);
    typeDataArr.indexOf(2) !== -1
      ? setDisplayHaulier(true)
      : setDisplayHaulier(false);
    typeDataArr.indexOf(4) !== -1 && typeDataArr.indexOf(2) !== -1
      ? setHaulierNum(3)
      : setHaulierNum(2);
  }, [typeData]);

  return (
    <DocumentListViewContainer>
      <SectionContainer>
        <HeaderRow>
          {(isCompanyCreation || isCenterCreation) && (
            <HeaderButton
              marginRight="10px"
              color={
                activeTab === "company"
                  ? companyData?.id
                    ? "#008395"
                    : "#00AEEA"
                  : "#cccccc"
              }
              zIndex="999"
              width="102%"
              onClick={() => toggleTab("company")}
            >
              <Circle color={activeTab === "company" ? "#00AEEA" : "#cccccc"}>
                1
              </Circle>
              <span>{t("COMPANY_INFORMATION")}</span>
            </HeaderButton>
          )}

          {displayCenter && (
            <HeaderButton
              marginRight="10px"
              color={activeTab === "center" ? "#00AEEA" : "#cccccc"}
              zIndex="998"
              onClick={() => toggleTab("center")}
            >
              <Circle color={activeTab === "center" ? "#00AEEA" : "#cccccc"}>
                2
              </Circle>
              <span>{t("CENTRE_INFORMATION")}</span>
            </HeaderButton>
          )}
          {displayHaulier && (
            <HeaderButton
              marginRight="10px"
              color={activeTab === "haulier" ? "#00AEEA" : "#cccccc"}
              width="103%"
              marginLeft="-7px"
              onClick={() => toggleTab("haulier")}
            >
              <Circle color={activeTab === "haulier" ? "#00AEEA" : "#cccccc"}>
                {haulierNum}
              </Circle>
              <span>{t("HAULIER_INFORMATION")}</span>
            </HeaderButton>
          )}
        </HeaderRow>
        {activeTab === "company" && (
          <Company
            id={id}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            isEditMode={isEditMode}
            setTypeData={setTypeData}
            typeData={typeData}
            setActiveTab={setActiveTab}
            leadId={leadId}
          />
        )}
        {activeTab === "center" && (
          <Centre
            id={id}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            isEditMode={isEditMode}
            setTypeData={setTypeData}
            typeData={typeData}
            setActiveTab={setActiveTab}
            leadId={leadId}
          />
        )}
        {activeTab === "haulier" && (
          <div>
            <Haulier
              id={id}
              selectedCompany={selectedCompany}
              setSelectedCompany={setSelectedCompany}
              isEditMode={isEditMode}
              setTypeData={setTypeData}
              typeData={typeData}
              leadId={leadId}
            />
          </div>
        )}
      </SectionContainer>
    </DocumentListViewContainer>
  );
};
AddEditCompany.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  isEditMode: PropTypes.bool,
  isCompanyCreation: PropTypes.bool,
  isCenterCreation: PropTypes.bool,
  companyData: PropTypes.object,
};
AddEditCompany.defaultProps = {
  id: null,
  isEditMode: false,
  isCompanyCreation: true,
  isCenterCreation: false,
  companyData: null,
};

export default withTranslation()(AddEditCompany);
